import React from 'react'
import { useSelector } from 'react-redux'
import { usePreloadCategories } from 'cityads-v3/utils/useUtils'
import { RootState } from 'cityads-v3/types/reducer'

type CategoryProps = {
  children(name: string): JSX.Element
  id: string | number
  manualFetch: boolean
}

export default function Category({ id, children, manualFetch }: CategoryProps) {
  const category = useSelector((state: RootState) => state.offers.categoriesById[id]);
  usePreloadCategories(manualFetch);

  return (
    children ?
      category?.name ? children(category.name) : null
      :
      <>{category?.name}</>
  )
}
